// extracted by mini-css-extract-plugin
export default {"overlays":"rvILJX_Ph4p5Mv5Yamod"};